import StripeDocument from './StripeDocument';
import { EVIDENCE_OPTIONS } from './EvidenceForm.stripe.schema';

export const UploadedDocumentList = ({
  onDeleteClick,
  documentList,
  disputeId,
}) => {
  return (
    <div className="mt-4">
      {documentList.map((file) => (
        <div
          className="mb-4 flex flex-col lg:flex-row lg:items-center"
          key={file.id}
        >
          <span className="pb-1 text-xs text-javelin-gray-light lg:w-4/12 lg:pb-0">
            Uploaded Document{' '}
            {
              EVIDENCE_OPTIONS.find((option) => option.value === file.type)
                .label
            }
          </span>
          <StripeDocument
            document={file}
            disputeId={disputeId}
            onDeleteClick={onDeleteClick}
          />
        </div>
      ))}
    </div>
  );
};
